import getConfig from 'next/config';

export function getApiV1Url() {
  const { publicRuntimeConfig: { API_BASE_URL } } = getConfig();
  return `${API_BASE_URL}/v1`;
}

export function getApiV2Url() {
  const { publicRuntimeConfig: { API_BASE_URL } } = getConfig();
  return `${API_BASE_URL}/v2`;
}

export function getApiV3Url() {
  const { publicRuntimeConfig: { API_BASE_URL } } = getConfig();
  return `${API_BASE_URL}/v3`;
}

export function getApiV4Url() {
  const { publicRuntimeConfig: { API_BASE_URL } } = getConfig();
  return `${API_BASE_URL}/v4`;
}
